import { getIsLoggedIn, getIsMobile, getIsCookieBannerVisible, } from '../../publicSession/selectors';
export var getDuperRedirectThreshold = function (state) {
    return getIsMobile(state) ? 2 : 3;
};
export var isBannerVisible = function (state) {
    return !getIsLoggedIn(state) && !getIsCookieBannerVisible(state);
};
//# sourceMappingURL=selectors.js.map